import { GET } from "../hooks/constants";
import { HttpCALLWithToken } from "../hooks/useHttps";
import { AppMaster } from "./networkSettings";

export const getGlobalData = async (token) => {
  const res = await HttpCALLWithToken(`${AppMaster}`, GET, token);
  if (res.data && res.data.data) {
    globalThis.masters = res.data.data;
  } else {
    globalThis.masters = {
      jobSites: [],
      roles: [],
      organizations: [],
      trades: [],
      brands: [],
    };
  }
  return res;
};
